module.exports = require("./ne.d.ts");